import { combineReducers } from '@reduxjs/toolkit';
import groupReducer from './groupReducer';

const rootReducer = combineReducers({
  group: groupReducer
});

export default rootReducer;
